import React from "react";
import Field from "./Field";

const FieldsTable = ({ config, handleEdit, handleDelete }) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Index</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {config && config.length > 0 ? (
          config.map((field, index) => (
            <React.Fragment key={index}>
              <Field field={field} onDelete={handleDelete} onEdit={handleEdit} config={config} />
              {field.type === "recordset-list" && (
                <tr style={{ /*backgroundColor: "#f5f5f5"*/ backgroundColor: "var(--builder-active1)" }}>
                  <td colSpan={"4"}>
                    <FieldsTable config={field.sub_fields || []} handleEdit={handleEdit} handleDelete={handleDelete} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
        ) : (
          <tr>
            <td colSpan={"4"} style={{ textAlign: "center", fontSize: "14px" }}>
              No data found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default FieldsTable;
